import gql from 'graphql-tag'

export const GET_NOTIFICATION_GROUPS = gql`
  query Ngroups($filter: GetNgroupsFilter) {
    ngroups(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      ngroups {
        data {
          aggregate {
            totalRecipients {
              whatsapp
              email
            }
          }
          ngroupId
          createdBy
          name
          referenceId
          referenceName
          creator {
            fullname
          }
          ngroup2AlertCode {
            alertCode
            alertCodeData {
              alertCode
              descriptionEng
              descriptionIdn
            }
          }
          ngroup2Geofence {
            geofenceId
            type
            geofence {
              fenceName
            }
          }
        }
        pagination {
          page
          show
          total
        }
        aggregate {
          totalRecipients {
            whatsapp
            email
          }
        }
      }
    }
  }
`

export const GET_NOTIFICATION_GROUP = gql`
  query Ngroup($filter: GetNgroupFilter!) {
    ngroup(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      ngroup {
        name
        referenceId
        referenceName
        creator {
          fullname
        }
        ngroupId
        ngroup2AlertCode {
          alertCode
          alertCodeData {
            alertCode
            descriptionEng
            descriptionIdn
          }
        }
        ngroup2Geofence {
          geofenceId
          geofence {
            fenceName
          }
          type
        }
      }
    }
  }
`

export const CREATE_NOTIFICATION_GROUP = gql`
  mutation CreateNgroup($input: CreateNgroupInput!) {
    createNgroup(input: $input) {
      isSuccessful
      errorCode
      errorName
      message
      status
      createNgroup {
        ngroupId
      }
    }
  }
`

export const UPDATE_NOTIFICATION_GROUP = gql`
  mutation UpdateNgroup($input: UpdateNgroupInput!) {
    updateNgroup(input: $input) {
      isSuccessful
      errorCode
      errorName
      message
      status
      updateNgroup {
        ngroupId
      }
    }
  }
`

export const DELETE_NOTIFICATION_GROUP = gql`
  mutation DeleteNgroup($input: DeleteNgroupInput!) {
    deleteNgroup(input: $input) {
      isSuccessful
      errorCode
      errorName
      message
      status
    }
  }
`
